import { makeStyles, tokens } from '@fluentui/react-components';

export const usePermissionsPageStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
    minWidth: '0',
  },

  header: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXXS,
    paddingBottom: tokens.spacingVerticalL,
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: tokens.colorNeutralStroke2,
    marginBottom: tokens.spacingVerticalNone,
  },

  titleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS,
  },

  infoButton: {
    color: tokens.colorNeutralForeground3,
    minWidth: 'unset',
  },

  description: {
    color: tokens.colorNeutralForeground2,
    maxWidth: '680px',
  },

  content: {
    display: 'flex',
    flexDirection: 'column',
  },

  saveRow: {
    paddingTop: tokens.spacingVerticalXL,
    paddingBottom: tokens.spacingVerticalL,
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalM,
  },

  saveError: {
    color: tokens.colorPaletteRedForeground1,
    fontSize: tokens.fontSizeBase200,
  },

  saveSuccess: {
    color: tokens.colorPaletteGreenForeground1,
    fontSize: tokens.fontSizeBase200,
  },

  signIn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flex: '1',
    gap: tokens.spacingVerticalL,
    textAlign: 'center',
  },

  loginError: {
    color: tokens.colorPaletteRedForeground1,
  },

  accessDenied: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flex: '1',
    gap: tokens.spacingVerticalM,
    textAlign: 'center',
    color: tokens.colorNeutralForeground2,
  },
});
